<script>
    import { isMobile } from "../../stores";

    export let manualClass = "";
    export let isDisabled = false;
    export let defaultClass = `btn btn-sm btn-secondary rounded text-white text-sm flex-none border-none w-auto h-10 ${
        $isMobile ? "" : "min-w-[200px]"
    }`;
    export let clickFunc = () => {};
    export let disabledTooltip = "";

    $: disabledTooltipText = isDisabled ? disabledTooltip : "";
</script>

<div
    class={disabledTooltipText
        ? "tooltip cursor-not-allowed"
        : isDisabled
        ? "cursor-not-allowed"
        : ""}
    data-tip={disabledTooltipText}
>
    <button
        class={defaultClass + " " + manualClass}
        disabled={isDisabled}
        on:click|preventDefault={clickFunc}
    >
        <slot />
    </button>
</div>

<style>
    button {
        box-shadow: 0px 4px 10px rgba(62, 62, 62, 0.24);
    }

    button:disabled {
        opacity: 1;
        background-color: rgb(243 244 246);
        color: rgb(209 213 219);
    }
</style>
